<template>
  <div>
    <el-row>
      <el-col :span="4">
        <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" v-model.trim="condition.phone" @keyup.enter.native="onSearch()">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-select placeholder="学期" v-model="condition.termId" size="medium" class="margin-left-20px">
          <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select placeholder="大学" v-model="condition.groupNumber" size="medium" class="margin-left-20px">
          <el-option v-for="item in universityGroups" :key="item.GroupNumber" :label="item.NameValue" :value="item.GroupNumber">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button size="medium" type="primary" @click="onSearch()" class="margin-left-20px">搜索</el-button>
      </el-col>
    </el-row>
    <pagination v-loading="loading" :data="listData" :option="paginationOption" @search="search" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
      @currentPageChange="currentPageChange" @additional="onAdditional">
      <template #IsSignedIn="{row}">
        <span>{{row.IsSignedIn ? "是" : "否"}}</span>
      </template>
      <template #IsWatchedVideo="{row}">
        <span>{{row.IsWatchedVideo ? "是" : "否"}}</span>
      </template>
    </pagination>
  </div>
</template>

<script>
import { getTerms, getUniversityGroups } from "@/service/common.service";
import {
  getFreeTrialCoursePageData,
  getActiveWorkflowDataByStudentId,
  removeWorkflow,
} from "@/service/enrollmentFee.service";

export default {
  name: "freeTrialCourseList",
  components: {
    pagination: () => import("@/components/common/pagination"),
  },
  data() {
    return {
      loading: false,
      listData: [],
      pageSize: 20,
      paginationOption: {},
      termList: [],
      universityGroups: [],
      condition: {
        phone: "",
        termId: "",
        groupNumber: "",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async getActiveWorkflowDataByStudentIdFromServer(studentId) {
      let activeWorkflow = null;

      try {
        let result = await getActiveWorkflowDataByStudentId(studentId, 2);
        if (!!result && result.success) {
          activeWorkflow = result.data;
        }
      } catch (error) {}

      return activeWorkflow;
    },
    async removeWorkflowToServer(workflowId) {
      let isSuccess = false;

      try {
        let result = await removeWorkflow(workflowId);
        if (!!result && result.success) {
          isSuccess = true;
          this.$message({
            message: "撤销流程成功",
            type: "success",
          });
        }
      } catch (error) {}

      return isSuccess;
    },
    gotoCourseEnrollmentFeeForEnrollCourse(studentId) {
      let path = "/addCollectFees/courseEnrollmentFee";
      this.$router.push({
        path: path,
        query: {
          studentId,
          workflowId: 0,
          initType: 1,
        },
      });
    },

    init() {
      let columns = [];
      columns.push({ name: "EnrollCourse", title: "", buttonText: "补款", fnDisabled: this.getEnrollCourseDisabled, });

      this.paginationOption = {
        displayPagination: true,
        hasEditButton: false,
        hasAddButton: false,
        hasSearch: false,
        hasDeleteButton: false,
        buttonWidth: 100,
        isNotStudent: !this.USERMANAGER.isStudent,
        additionalColumns: columns,
      };

      getTerms(false, true, true).then((result) => {
        if (!!result && result.success) {
          this.termList = result.data;
          this.termList.splice(0, 0, {
            Id: -1,
            DisplayLable: "不限学期",
          });
          this.condition.termId = -1;
        }
      });

      getUniversityGroups().then((result) => {
        if (!!result && result.success) {
          this.universityGroups = result.data;
          this.universityGroups.splice(0, 0, {
            GroupNumber: -1,
            NameValue: "不限大学",
          });
          this.condition.groupNumber = -1;
        }
      });
      this.search();
    },
    onSearch() {
      this.search();
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    async onAdditional(name, index, row) {
      switch (name) {
        case "EnrollCourse": {
          let activeWorkflow =
            await this.getActiveWorkflowDataByStudentIdFromServer(
              row.StudentId
            );
          if (!!activeWorkflow.Id) {
            this.$confirm(
              "该学生已有未完成的报课流程, 是否撤销该流程并继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                let result = await this.removeWorkflowToServer(
                  activeWorkflow.Id
                );
                if (result) {
                  this.gotoCourseEnrollmentFeeForEnrollCourse(row.StudentId);
                }
              })
              .catch(() => {});
          } else {
            this.gotoCourseEnrollmentFeeForEnrollCourse(row.StudentId);
          }
          break;
        }
      }
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    loadListData(pageData) {
      this.loading = true;
      getFreeTrialCoursePageData(pageData)
        .then((result) => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let additionalFilter = {
        termId: this.condition.termId,
        groupNumber: this.condition.groupNumber,
      };
      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.condition.phone,
        additionalFilter: additionalFilter,
      };

      return pageData;
    },
    getEnrollCourseDisabled(index, row){
      if (!!row.CanEnrollCourse) {
        return false;
      } else {
        return true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/addCollectFees/freeTrialCourseList.vue